export const DELETE_CONTENT_BACKWARD = 'deleteContentBackward'